import React, { useState, useEffect } from 'react';
import { Modal, Button, Radio, Row, Col, message } from 'antd';
import {
    LoadingOutlined
} from '@ant-design/icons';
import axios from 'axios';
import ENVIRONMENT from '../../../../environments';
import SubscriptionUpgradeManager from '../SubscriptionUpgradeManager/SubscriptionUpgradeManager';
import './HighResModal.scss';

const UpscaleImageModal = ({ isOpen, onClose, renderId, onSuccess }) => {
    const [resolution, setResolution] = useState('4k');
    const [isLoading, setIsLoading] = useState(false);
    const [requestStatus, setRequestStatus] = useState(null);
    const [cardStatus, setCardStatus] = useState(0);
    const [subscriptionUpgradeManagerModel, setSubscriptionUpgradeManagerModel] = useState(false);
    const [pendingRequest, setPendingRequest] = useState(false);

    useEffect(() => {
        if (isOpen) {
            setResolution('4k');
            loadUserRequestStatus();
        }
    }, [isOpen]);

    useEffect(() => {
        if (pendingRequest && requestStatus !== null) {
            setPendingRequest(false);
            if (requestStatus === 'allowed' || requestStatus === 'always_allowed') {
                submitUpscale();
            } else {
                setIsLoading(false);
                setSubscriptionUpgradeManagerModel(true);
            }
        }
    }, [requestStatus, pendingRequest]);

    const loadUserRequestStatus = () => {
        const payload = {
            username: localStorage.getItem('username'),
            request_type: 'ai_image_4k',
            action: 'check',
            category: '',
        };
        axios.post(ENVIRONMENT.PAYMENT_GATEWAY, payload)
            .then((res) => {
                setRequestStatus(res.data['request_allowed']);
                setCardStatus(res.data['card_status']);
            })
            .catch((error) => {
                console.error('Error checking request status:', error);
                setRequestStatus('update_subscription');
            });
    };

    const handleConfirm = () => {
        if (requestStatus === null) {
            setIsLoading(true);
            setPendingRequest(true);
            loadUserRequestStatus();
            return;
        }

        if (requestStatus === 'allowed' || requestStatus === 'always_allowed') {
            submitUpscale();
        } else {
            setSubscriptionUpgradeManagerModel(true);
        }
    };

    const submitUpscale = () => {
        if (!renderId) return;
        setIsLoading(true);
        const scale = resolution === '4k' ? 4 : 2;
        const username = localStorage.getItem('username');
        const companyId = localStorage.getItem('company_id');

        message.loading('Requesting upscale image..');
        const request_payload = {
            action: 'generate_4k_image',
            base_image_id: renderId,
            username: username,
            company_id: companyId,
            scale: scale,
        };

        const gateway_payload = {
            username: username,
            request_type: 'ai_image_4k',
            action: 'perform',
            request_payload: request_payload,
            category: '',
            request_id: Date.now().toString(),
        };

        axios.post(ENVIRONMENT.PAYMENT_GATEWAY, gateway_payload)
            .then(() => {
                setIsLoading(false);
                message.success(`${resolution.toUpperCase()} upscale submitted successfully!`);
                onClose();
                if (onSuccess) onSuccess();
            })
            .catch((error) => {
                console.error('Error submitting upscale image:', error);
                setIsLoading(false);
                message.error('An error occurred while submitting upscale image.');
            });
    };

    return (
        <>
            <Modal
                className='high-res-modal'
                visible={isOpen}
                onCancel={onClose}
                title={<span className="manrope f-20 lh-28 w-500 black-085 justify-in-start">
                    Upscale Image
                </span>}
                closable={true}
                footer={[
                    <div className='justify-in-end' key="footer">
                        <Button className='manrope f-14 w-500 lh-22 ai-action-btn pd-small' onClick={onClose}>Cancel</Button>
                        <Button className='manrope f-14 w-500 lh-22 ai-action-btn-blue pd-small' onClick={handleConfirm}>
                            {isLoading && <LoadingOutlined />}
                            Confirm
                        </Button>
                    </div>
                ]}
                centered={true}>
                <Row>
                    <Col span={24} className='direction-flex col j-start-a-start'>
                        <div className='manrope f-14 w-700 lh-22 black-085'>Resolution</div>
                        <Radio.Group value={resolution} onChange={(e) => setResolution(e.target.value)}>
                            <Radio value="4k" className='manrope f-14 w-400 lh-22 black-085'>4K (4096x4096)</Radio>
                            <Radio value="2k" className='manrope f-14 w-400 lh-22 black-085'>2K (2048x2048)</Radio>
                        </Radio.Group>
                    </Col>
                </Row>
            </Modal>
            <SubscriptionUpgradeManager
                subscriptionUpgradeManagerModel={subscriptionUpgradeManagerModel}
                setSubscriptionUpgradeManagerModel={setSubscriptionUpgradeManagerModel}
                cardStatus={cardStatus}
                loadUserRequestStatus={loadUserRequestStatus}
                requestType='ai_image_4k'
            />
        </>
    );
};

export default UpscaleImageModal;
